import { Injectable } from '@angular/core';

// This class is used as a check for the window object.
// In server side rendering, window is not available and does not exist.
// We need this so we can determine if we are in the browser or on the server.
@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  get nativeWindow(): Window | null {
    return typeof window !== 'undefined' ? window : null;
  }
}
